const isWithinOpeningHours = () => {
    const now = new Date();
    const hour = now.getHours();
    return hour >= 8 && hour < 23;
};

const initChat = () => {
    const getElementForChat = document.querySelector('#vue-chat');

    const bindVueElementVueChat = () => {
        const CreateVueChat = new Vue({
            el: '#vue-chat',
            template: `
            <div class="vue-chat" v-if="active">
                <div
                    v-if="!chatOpen"
                    :class="miniMessage ? 'vue-chat__cloud active' : 'vue-chat__cloud'"
                    @click="chatOpen = 1"
                    >
                    <div class="vue-chat__icon"></div>
                </div>
                <div :class="miniMessage ? 'vue-chat__slide active' : 'vue-chat__slide'">
                    <span>Kan ik je ergens mee helpen?</span>
                </div> 
                <div :class="megaMessage ? 'vue-chat__slide--mega active' : 'vue-chat__slide--mega'">
                    <div class="vue-chat__box__chat">
                        <div class="vue-chat__slide--mega__close" @click="megaMessage = 0">+</div>
                        <div class="vue-chat__box__chat__header">
                            <div class="vue-chat__box__avatar__image">
                                <img src="">
                            </div>
                            <div class="vue-chat__box__chat__header__sub">
                                <h3>Rick van CarOptions</h3>
                                <span class="vue-chat__box__state">Online</span>
                            </div>
                            
                            </div>    
                            <p>Hey 👋🏼! Ook op <b>zondag</b> zijn wij online om je te helpen met jouw aankoop. Mis jouw <strong>Black Friday Deal</strong> niet! Vragen? Chat nu!</p>
                        </div>
                        <div class="vue-chat__mega-sub">
                            <span class="mega-time">{{ timeMega }}</span>
                            <div class="mega-check"></div>
                        </div>
                </div>
                <div class="vue-chat__box" v-if="chatOpen">
                    <div class="vue-chat__box__wrapper">
                        <div class="vue-chat__box__header">
                            <div class="vue-chat__box__avatar">
                                <div class="vue-chat__box__avatar__image">
                                    <img src="">
                                </div>
                                <div :class="isWithinOpeningHours() ? 'vue-chat__box__avatar__whatsapp' : 'vue-chat__box__avatar__whatsapp offline'"></div>
                            </div>
                            <div class="vue-chat__box__name">
                                <h4>Rick van CarOptions</h4>
                                <span v-if="state" class="vue-chat__box__state active">{{ isWithinOpeningHours() ? 'Online' : 'Offline'}}</span>
                                <span v-else class="vue-chat__box__state">is aan het typen...</span>
                            </div>
                            <div
                                class="vue-chat__box__close"
                                @click="close()"
                            ></div>
                        </div>
                        <div class="vue-chat__box__inner">
                            <div class="vue-chat__box__chats">
                                <div class="vue-chat__box__chat" v-if="chat">
                                    <div class="vue-chat__box__text">
                                        {{ chat }}
                                    </div>
                                    <div class="vue-chat__box__sub">
                                        <span class="time">{{time}}</span>
                                        <div class="check"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vue-chat__box__send">
                            <textarea v-model="message" ref="textarea" v-on:input="adjustTextareaHeight" type="text" placeholder="Type een bericht.."></textarea>
                            <div @click="send()" :class="message ? 'vue-chat__box__submit active' : 'vue-chat__box__submit'"></div>
                        </div>
                    </div>
                </div>
            </div>
        `,
            data: {
                active: false,
                chatOpen : 0,
                messageType : 'mini',
                miniMessage : 0,
                megaMessage : 0,
                state: 0,
                chat: '',
                message : '',
                time : '',
                timeMega : '',
                openingHours: "dagelijks van 9:00 tot 23:00",
            },

            watch: {
                chatOpen() {
                    setTimeout(() => {
                        this.state = 1;
                    }, 1000);

                    setTimeout(() => {
                        if (isWithinOpeningHours()) {
                            this.chat = "Hulp nodig? Ons team staat klaar om je te helpen.";
                        } else {
                            this.chat = `Stuur mij gerust je vragen als ik offline ben. Ik beantwoord je berichtje ${this.openingHours}.`;
                        }

                        if (!this.time) {
                            const currentTime = new Date();
                            const hours = String(currentTime.getHours()).padStart(2, '0');
                            const minutes = String(currentTime.getMinutes()).padStart(2, '0');
                            this.time = hours + ":" + minutes;
                        }
                    }, 1200);
                }
            },

            mounted() {
                const getMessage = sessionStorage.getItem('vue-chat');
                if (!getMessage) {
                    if (this.messageType === 'mini') {
                        setTimeout(() => {
                            this.miniMessage = 1;
                        }, 4000);

                        setTimeout(() => {
                            this.miniMessage = 0;
                        }, 11000);
                    } else if (this.messageType === 'mega') {
                        setTimeout(() => {
                            this.megaMessage = 1;
                        }, 4000);

                        setTimeout(() => {
                            this.megaMessage = 0;
                        }, 16000);
                    }

                    sessionStorage.setItem('vue-chat', 1);
                }

                const currentTime = new Date();
                const hours = String(currentTime.getHours()).padStart(2, '0');
                const minutes = String(currentTime.getMinutes()).padStart(2, '0');
                this.timeMega = hours + ":" + minutes;

                this.setActiveOnMounted();
            },
            methods: {
                send() {
                    const nr = '31850606177'
                    const message = encodeURIComponent(this.message);
                    const url = `https://api.whatsapp.com/send/?phone=${nr}&text=${message}%0A%0A&type=phone_number&app_absent=0`;
                    window.open(url, '_blank');
                    this.close();
                },

                close() {
                    this.chatOpen = 0;
                },

                adjustTextareaHeight() {
                    const textarea = this.$refs.textarea;
                    textarea.style.height = 'auto';
                    const lineHeight = parseInt(getComputedStyle(textarea).lineHeight);
                    const minHeight = lineHeight * 2;
                    const scrollHeight = textarea.scrollHeight;
                    textarea.style.height = Math.max(minHeight, scrollHeight) - 22 + 'px';
                },

                setActiveOnMounted() {
                    this.active = true;
                }
            }
        });
    }

    if (getElementForChat) {
        bindVueElementVueChat();
    }
}

initChat();
